import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PayPalNewComponent } from './components/paypal-new.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    PayPalNewComponent
  ],
  exports: [
    PayPalNewComponent
  ]
})
export class PaypalNewModule { }
